@if (icon) {
  <mat-icon>{{ icon }}</mat-icon>
}
<div style="flex: 1">
  <ng-content></ng-content>
</div>

<mat-icon>keyboard_arrow_right</mat-icon>
